import { createAuthClient } from 'better-auth/react'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787'

function getValidBaseUrl(url: string) {
  if (!url.startsWith('http')) {
    return `https://${url}`
  }
  return url
}

export const authClient = createAuthClient({
  baseURL: getValidBaseUrl(API_BASE_URL),
})

// Export convenience methods
// Export convenience methods
export const { signIn, signUp, signOut, useSession, getSession } = authClient
